import React, { useId } from "react";

import { cn } from "~/lib/cn";

export const LogoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  // One gradient id per instance: a shared id resolves to the first copy in
  // the page, and that copy paints nothing when it sits inside a hidden
  // element, such as the collapsed sidebar's icon.
  const gradientId = `dcm-logo-${useId().replaceAll(":", "")}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="235"
      height="235"
      viewBox="0 0 163 163"
      {...props}
      className={cn("dcm-logo", props.className)}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="-.42"
          y1="56.45"
          x2="130.55"
          y2="77.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="var(--color-purple-600)" />
          <stop offset="1" stopColor="var(--color-violet-600)" />
        </linearGradient>
      </defs>
      <g transform="translate(14.700554,13.964789)">
        <g className="dcm-logo__shape">
          <path
            d="M36.06 109.13l-9.45-8.52c-7.08-6.78-13.52-14.1-18.74-22.44-2.86-4.58-5.28-9.36-6.72-14.59C.01 59.42-.43 55.22.51 50.95a26.5 26.5 0 0 1 3.54-8.4c3.14-5.02 7.23-9.17 11.77-12.89 9.17-7.51 19.46-13.12 30.29-17.79 10.1-4.35 20.51-7.7 31.31-9.83C85.35.48 93.34-.41 101.44.17a42.6 42.6 0 0 1 12.22 2.55c5.61 2.14 9.75 5.94 12.66 11.14 2.34 4.18 3.82 8.67 4.86 13.31a94.6 94.6 0 0 1 2.11 20.2c.09 16.36-2.38 32.35-7.23 47.97a104.9 104.9 0 0 1-7.87 18.98 57.1 57.1 0 0 1-7.95 11.42c-2.52 2.76-5.38 5.12-8.77 6.76-4.15 2-8.56 2.49-13.1 2.19-5.36-.35-10.5-1.73-15.51-3.59-5.55-2.05-10.84-4.67-15.97-7.63-3.88-2.24-7.66-4.63-11.3-7.23-3.12-2.24-6.16-4.6-9.51-7.12"
            clipRule="evenodd"
            fill={`url(#${gradientId})`}
          />
        </g>
        <path
          d="M68.07 89.11c11.91 1.31 24.87-4.73 29.36-16.3 5.78-13.13-1.21-30.06-14.84-34.86-12.15-4.84-29.24.16-33.12 13.62-4.07 7.8 7.45 15.88 12.16 7.76 2.51-7.84 10.53-5.17 16.7-6.15 7.55.75-1.61 10.05-1.78 14.44l-8.46 21.47m-6.44 15.65c-5.06-.63-13.39 1.1-16.4-1.11l10.42-25.23c-12.37.59-23.25-10.95-22.34-23.23.08-17.24 14.9-31.86 31.63-33.99 17.3-3.35 36.29 4.95 44.71 20.59 9.64 16.83 6.17 40.15-8.99 52.64-9.05 8.08-21.47 11.37-33.41 10.32-1.87 0-3.74-.01-5.61.02z"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};
